var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttchementIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.93329 4.60405L5.10412 8.43322C4.63502 8.90232 3.99878 9.16586 3.33537 9.16586C2.67196 9.16586 2.03573 8.90232 1.56662 8.43322C1.09752 7.96412 0.833984 7.32788 0.833984 6.66447C0.833984 6.00106 1.09752 5.36482 1.56662 4.89572L5.39579 1.06655C5.70853 0.753817 6.13268 0.578125 6.57496 0.578125C7.01723 0.578125 7.44139 0.753817 7.75412 1.06655C8.06686 1.37929 8.24255 1.80345 8.24255 2.24572C8.24255 2.68799 8.06686 3.11215 7.75412 3.42489L3.92079 7.25405C3.76442 7.41042 3.55234 7.49827 3.33121 7.49827C3.11007 7.49827 2.89799 7.41042 2.74162 7.25405C2.58526 7.09768 2.49741 6.88561 2.49741 6.66447C2.49741 6.44333 2.58526 6.23125 2.74162 6.07489L6.27912 2.54155",
    stroke: "black",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttchementIcon);
export default __webpack_public_path__ + "static/media/AttchementIcon.79362e962244da0dcf995d6384b84714.svg";
export { ForwardRef as ReactComponent };